<!-- No subscription: select a plan (moved from dashboard) -->
<ng-container *ngIf="showChooseSubscription">
    <div class="choose-subscription-block">
        <div class="step-text mb-4">
            <h2 class="step-title">
                Scegli un <span class="gradient-text">abbonamento</span>
            </h2>
            <span class="step-subtitle">
                <i class="bi bi-list-check"></i>
                Non hai ancora un abbonamento attivo. Seleziona il piano per la tua società.
            </span>
        </div>

        <ng-container *ngIf="!showStripeCheckout">
            <div class="plan-card-container" *ngIf="services && services.length">
                <div class="plan-header">
                    <div>
                        <h3 class="plan-title">Scegli il piano giusto per te</h3>
                        <p class="plan-subtitle">Prezzi semplici e trasparenti. Nessun costo nascosto.</p>
                    </div>
                    <div class="billing-toggle">
                        <button type="button" class="billing-pill" [class.active]="billingPeriod === 'monthly'" (click)="billingPeriod = 'monthly'">Mensile</button>
                        <button type="button" class="billing-pill" [class.active]="billingPeriod === 'yearly'" (click)="billingPeriod = 'yearly'">Annuale</button>
                    </div>
                </div>
                <div class="plans-grid">
                    <div class="plan-card" *ngFor="let service of services; let i = index" (click)="selectPlan(service)">
                        <div class="plan-badge" *ngIf="i === 1">Più scelto</div>
                        <h4 class="plan-name">{{ service.name }}</h4>
                        <div class="plan-billing-label">{{ billingPeriod === 'monthly' ? 'Canone mensile' : 'Canone ogni ' + getServiceRecurrencyMonths(service) + ' mesi' }}</div>
                        <div class="plan-price">
                            <div class="plan-price-main">
                                <span class="amount">{{ getDisplayedMonthlyPrice(service) | number:'1.2-2' }}€</span>
                                <span class="period">{{ billingPeriod === 'monthly' ? '/mese' : '/' + getServiceRecurrencyMonths(service) + ' mesi' }}</span>
                            </div>
                            <div *ngIf="billingPeriod === 'monthly' && getAnnualSavingsPercent(service) as savePct" class="plan-price-billed plan-savings">
                                Risparmia il <strong>{{ savePct }}%</strong> con il piano ogni {{ getServiceRecurrencyMonths(service) }} mesi
                            </div>
                            <div *ngIf="billingPeriod === 'yearly'" class="plan-price-billed">
                                <span>~{{ getAnnualBilledMonthlyPrice(service) | number:'1.2-2' }}€/mese</span>
                                <span *ngIf="getAnnualSavingsPercent(service) as savePct"> · −{{ savePct }}% rispetto al mensile</span>
                            </div>
                            <div *ngIf="billingPeriod === 'monthly'" class="plan-price-billed smaller-text">
                                {{ getAnnualBilledMonthlyPrice(service) | number:'1.2-2' }}€/mese se fatturato ogni {{ getServiceRecurrencyMonths(service) }} mesi
                            </div>
                        </div>
                        <ul class="plan-features">
                            <li *ngFor="let feature of service.features">{{ getFeatureLabel(feature) }}</li>
                        </ul>
                        <button type="button" class="btn w-100 plan-cta" [ngClass]="setCheckbox(service) ? 'btn-dark' : 'btn-outline-dark'">
                            {{ setCheckbox(service) ? 'Piano selezionato' : 'Conferma piano' }}
                        </button>
                    </div>
                </div>
                <p class="plan-note smaller-text mb-4" *ngIf="billingPeriod === 'yearly' && servicesSelected.length && getAnnualSavingsPercent(servicesSelected[0]) as footnotePct">
                    Stai risparmiando il <strong>{{ footnotePct }}%</strong> con il piano ogni {{ getServiceRecurrencyMonths(servicesSelected[0]) }} mesi.
                </p>
                <p class="plan-note smaller-text mb-4" *ngIf="billingPeriod === 'monthly'">
                    Passa al piano ricorrente per pagare ogni 6, 12 o 24 mesi e risparmiare sul canone mensile.
                </p>
                <div class="tariff-card" *ngIf="tariffTiers && tariffTiers.length">
                    <div class="tariff-header row g-0">
                        <div class="col-7 col-md-8"><span class="tariff-header-title">Esigenza</span></div>
                        <div class="col-5 col-md-4 text-end"><span class="tariff-header-title">Tariffa</span></div>
                    </div>
                    <div class="tariff-row row g-0" *ngFor="let tier of tariffTiers">
                        <div class="col-7 col-md-8"><span class="tariff-range" [class.tariff-range-strong]="tier.range === 'Iscrizioni illimitate'">{{ tier.range }}</span></div>
                        <div class="col-5 col-md-4 text-end"><span class="tariff-rate" [class.tariff-rate-strong]="tier.range === 'Iscrizioni illimitate'">{{ tier.rate }}</span></div>
                    </div>
                </div>
            </div>
            <div class="buttons mt-4">
                <button class="btn btn-primary px-5" [disabled]="servicesSelected.length === 0" (click)="goToPayment()">Continua al pagamento</button>
            </div>
        </ng-container>

        <ng-container *ngIf="showStripeCheckout">
            <div class="step-text mb-3">
                <h2 class="step-title">Completa il <span class="gradient-text">pagamento</span></h2>
                <span class="step-subtitle"><i class="bi bi-credit-card"></i> Finalizza l'attivazione del piano selezionato con pagamento sicuro tramite Stripe.</span>
            </div>
            <app-stripe-embedded-checkout
                *ngIf="servicesSelected.length"
                [planId]="servicesSelected[0].id"
                [billingPeriod]="billingPeriod"
                [companyId]="companyId"
                [useOldCompanyCheckout]="true"
                (paymentCompleted)="onSubscriptionPaymentCompleted()">
            </app-stripe-embedded-checkout>
            <div class="buttons mt-3">
                <button class="btn welldone-btn-light" (click)="backToPlanSelection()">Indietro</button>
            </div>
        </ng-container>
    </div>
</ng-container>
